import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export function isCutoutTreatment(onex: OnEx | undefined): boolean {
    return onex?.isExperimentGroup('CUTOUT_IMAGE', 'E3851B') ?? false;
}
